import { Replayer } from 'rrweb';
import { EventType } from '@replayops/rrweb-schema';
import { REPLAY_ANIMATION_RESET } from './replayStyle.js';
/**
 * Renders a live rrweb stream for operator co-watching. Buffers incoming events
 * until it has the first full snapshot (with its preceding Meta), then boots the
 * Replayer in live mode and feeds every subsequent event straight through. A new
 * full snapshot (e.g. the visitor navigated, or watching restarted) re-inits the
 * player so the DOM stays correct.
 */
export class LivePlayer {
    root;
    replayer;
    buffer = [];
    dims = { width: 0, height: 0 };
    onResize;
    constructor(root) {
        this.root = root;
    }
    /** Notified with the visitor's viewport dimensions for scaling. */
    onDimensions(cb) {
        this.onResize = cb;
        if (this.dims.width)
            cb(this.dims.width, this.dims.height);
    }
    addEvent(e) {
        if (e.type === EventType.Meta) {
            const d = e.data;
            if (d.width && d.height) {
                this.dims = { width: d.width, height: d.height };
                this.onResize?.(d.width, d.height);
            }
        }
        // A fresh full snapshot means "repaint from scratch": tear down and rebuild.
        if (e.type === EventType.FullSnapshot && this.replayer)
            this.reset();
        if (this.replayer) {
            this.replayer.addEvent(e);
            return;
        }
        this.buffer.push(e);
        if (this.buffer.some((x) => x.type === EventType.FullSnapshot))
            this.boot();
    }
    boot() {
        this.root.innerHTML = '';
        this.replayer = new Replayer(this.buffer, {
            root: this.root,
            liveMode: true,
            mouseTail: false,
            showWarning: false,
            showDebug: false,
            // Force content gated behind CSS entrance animations to paint at its
            // settled (visible) state — see REPLAY_ANIMATION_RESET.
            insertStyleRules: REPLAY_ANIMATION_RESET,
        });
        this.replayer.startLive(this.buffer[0].timestamp);
        this.buffer = [];
    }
    reset() {
        try {
            this.replayer?.pause();
        }
        catch {
            /* ignore */
        }
        this.replayer = undefined;
        this.buffer = [];
        this.root.innerHTML = '';
    }
    destroy() {
        this.reset();
    }
}
//# sourceMappingURL=livePlayer.js.map